export default {
  'devices.title': '设备列表',
  'devices.addDevice': '新增设备',
  'devices.column.name': '设备名',
  'devices.column.modelName': '设备型号',
  'devices.column.serialNumber': '设备序列号',
  'devices.column.macAddress': 'MAC地址',
  'devices.column.type': '设备类型',
  'devices.column.status': '设备状态',
  'devices.column.lastHeartBeatTime': '最近一次心跳时间',
  'devices.column.operation': '操作',
  'devices.column.appVersion': 'App版本号',
  'devices.column.name.required': '设备名必填',
  'devices.column.model_name.required': '设备别名必填',
  'devices.column.serial_number.required': '设备序列号必填',
  'devices.column.type.required': '设备类型必填',

  'devices.addDevice.title': '新增设备',
  'devices.printerSetting': '打印设置',
  'devices.editDevice.title': '编辑设备',
  'devices.deleteDevice.promptTitle': '设备删除提示',
  'devices.deleteDevice.promptContent': '确定要删除此设备吗？',
  'devices.isDeleting': '删除中',

  'devices.activateDevice.promptTitle': '设备激活提示',
  'devices.activateDevice.promptContent': '确定要激活此设备吗？',
  'devices.deactivateDevice.promptTitle': '设备冻结提示',
  'devices.deactivateDevice.promptContent': '确定要冻结此设备吗？',
  'devices.forbiddenDeletion': '该设备已被设为延迟送厨或自动接单的主设备。请更改主设备后再删除',
};
